import React, { useState, useCallback, useContext } from 'react';
import { Text, View, Pressable } from 'react-native';
import { EXPENSE } from './queries';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import SubNav from './SubNav';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   TitleContainer,
   PageTitle,
   SubNavContainer,
} from '../../elements';
import Modal from '../../elements/Modal';
import EditExpense from './edit';
import styled from 'styled-components/native';
import { useParams } from 'app/src/utils/routing';
import RequestPurchaseOrderNumber from './PurchaseOrders/RequestPurchaseOrderNumber';
import { Link } from 'app/src/utils/routing';
import { useForm } from 'react-hook-form';
import AuthContext from '../../contexts/AuthContext';
import DataTable from '@preflighttech/preflight-tables';
import elRed from '../../styles/colors';
import moment from 'moment';

const ExpenseDetails = styled(View)`
  display: flex;
  justify-content: flex-end;
  text-align: end;
`;

const DetailsText = styled(Text)`
  text-align: end;
`;

const PageTitleStatusContainer = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const StatusContainer = styled(Pressable)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 40px;
  width: fit-content;
  padding: 20px;
  margin-left: 40px;
  margin-top: -5px;
`;

const StatusText = styled(Text)`
  color: #fff;
  font-weight: bold;
`;

const Expense = () => {
  const { user } = useContext(AuthContext);
  let { expenseId } = useParams();
  const [showEditExpenseModal, setShowEditExpenseModal] = useState(false);
  const [showRequestNewPON, setShowRequestNewPON] = useState();

  const { loading, error, data, refetch } = useQuery(
    EXPENSE, { variables: { id: expenseId } }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createExpense({ variables: input });
  });

  const { control, handleSubmit, register, setValue, getValues,
      formState: { errors } } = useForm({
    defaultValues: {
      vendorId: '',
      requestedById: user?.id,
      invoiceNumber: '',
      description: ''
    }
  });

  if(loading) {
    return <DataState.Loading />;
  }

  const { expense } = data;

  const columns = [
    {
      key: 'userDescription',
      label: 'User',
      content: (entry) => {
        return entry.entry.userDescription
      }
    },
    {
      key: 'fields',
      label: 'Changes',
      content: ({ entry }) => {
        if (entry.expenseDescription) {
          return <Text>{entry.expenseDescription}</Text>;
        }

        return entry.fields.map(delta => {
          return (
            <View
              key={delta.name}
              style={{display: 'flex', flexDirection: 'row'}}
            >
              <Text>Name: </Text>
              <Text style={{fontWeight: 'bold'}}>{delta.name}, </Text>
              <Text>{`[Old Value: `}</Text>
              <Text style={{fontWeight: 'bold'}}>
                {['', null, undefined].includes(delta.oldValue) ?
                  'null' :
                  delta.oldValue
                }
              </Text>
              <Text>{` => New Value: `}</Text>
              <Text style={{fontWeight: 'bold'}}>{delta.newValue}</Text>
              <Text>{`]`}</Text>
            </View>
          )
        })
      }
    },
    {
      key: 'createdAt',
      label: 'Date',
      content: (entry) => moment(entry.entry.createdAt).format('MM-DD-YY')
    }
  ]

  return (
    <MainContainer>
      <SubNavContainer>
        {getSubNavContents()}
      </SubNavContainer>
      <ContentContainer>
        <TitleContainer id="titlecontainer">
          <PageTitleStatusContainer>
            <PageTitle>
              {getExpenseTitle()}
            </PageTitle>
            <StatusContainer
              onPress={() => setShowEditExpenseModal(true)}
            >
              <StatusText>{expense?.status}</StatusText>
            </StatusContainer>
          </PageTitleStatusContainer>
        </TitleContainer>
        <TableContainer style={{padding: '20px'}}>
          <EditExpense
            setShowModal={setShowEditExpenseModal}
            refetch={refetch}
            expense={expense}
            statusUpdate={true}
          />
        </TableContainer>
        <TableContainer style={{padding: '20px', marginTop: '10px'}}>
          <Text
            style={{color: elRed, fontSize: '20px', fontWeight: 'bold'}}
          >
            Expense History
          </Text>
          <DataTable.Simple
            data={expense?.expenseDeltas}
            columns={columns}
            htmlTable
          />
        </TableContainer>
      </ContentContainer>
      {showEditExpenseModal &&
        <Modal
          refetch={refetch}
          showModal={showEditExpenseModal}
          setShowModal={setShowEditExpenseModal}
          modalType={'Change Expense Status'}
          objectName={expense?.name}
        >
          <EditExpense
            setShowModal={setShowEditExpenseModal}
            refetch={refetch}
            expense={expense}
            statusUpdate={true}
            markAsPaid={true}
          />
        </Modal>
      }
    </MainContainer>
  );

  function getExpenseTitle() {
    if(expense?.purchaseOrderNumber) {
      return `Purchase Order: ${expense?.purchaseOrderNumber}`
    }else {
      return `Expense - ${expense?.status}`
    }
  }

  function getSubNavContents() {
    return (
      <View
        style={{
          display: 'flex',
          flex: 1,

        }}
      >
        {getLinks()}
      </View>
    )
    function getLinks() {
      return (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Link to={`/purchase-orders`}>
            <Text>Purchase Orders</Text>
          </Link>
          {expense?.status === 'Purchase Order' &&
            <Pressable
              onPress={() => setShowEditExpenseModal(true)}
            >
              <Text style={{fontWeight: 'bold'}}>Mark as Paid</Text>
            </Pressable>
          }
          <RequestPurchaseOrderNumber />
        </View>
      )
    }
  }
};

export default Expense;
